import QlikFilter from "./QlikFilter";
import React from 'react';
import ReactDOM from 'react-dom';
import getApp from './qapp';

ReactDOM.render(
  <QlikFilter name="Year" field="created.autoCalendar.Year"></QlikFilter>,
  document.getElementById('year-filter')
);
ReactDOM.render(
  <QlikFilter name="Month" field="created.autoCalendar.Month"></QlikFilter>,
  document.getElementById('month-filter')
);
ReactDOM.render(
  <QlikFilter name="Day" field="Day"></QlikFilter>,
  document.getElementById('day-filter')
);

getApp.then(app => {
  $("#loading").hide();
  $("#app").show();
  app.visualization.create('barchart',
    [{qDef: {qGrouping: 'H', qFieldDefs: ['created.autoCalendar.Year', 'created.autoCalendar.Month'], qFieldLabels: ['Year', 'Month'], qSortCriterias: [{qSortByNumeric: 1}, {qSortByNumeric: 1}]}},
    {qDef: {qDef: '=count([created])', qLabel: '# of Posts'}}],
    {orientation: 'horizontal'}
  ).then(function(viz){
    viz.show('barchart');
  });
  app.visualization.create('treemap',
    [{qDef: {qFieldDefs: ['created.autoCalendar.Year'], qFieldLabels: ['Year']}}, {qDef: {qFieldDefs: ['created.autoCalendar.Month'], qFieldLabels: ['Month']}}, 
    {qDef: {qDef: '=count(created)', qLabel: '# of Posts'}}],
    {}
  ).then(function(viz){
    viz.show('treemap');
  });
});




// WEBPACK FOOTER //
// ./main.js